import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { productMockup } from '../data/product';

/** PENDING: replace with the live checkout URL once the sales platform is defined. */
const CHECKOUT_URL = '#pricing';
const included = ['6 volumes · 72 stacked sessions', '5 instant-use bonuses', '300 landscape pages, screen or print', '432 ready targets at 3 levels', '48 take-home worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-blush text-ink" data-id="element-198" data-mp="1rujb018j9qwe">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-199" data-mp="20t4qtommerth">
        <div className="text-center" data-id="element-200" data-mp="20rjxg2c1lex7">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-201" data-mp="3h7egcm2lmmlw">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display text-plum text-3xl sm:text-5xl" data-id="element-202" data-mp="3c78k0sldwbxh">
            Everything you need to run the{' '}
            <span className="text-coral-deep" data-id="element-203" data-mp="4smc0jy9hrvm">next 36 weeks</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-blush-dark bg-white shadow-card" data-id="element-204" data-mp="9rpb7nrk93vo">
          <div className="bg-plum px-5 py-5 text-center" data-id="element-205" data-mp="erletlwcitap">
            <h3 className="font-display text-xl text-white sm:text-2xl" data-id="element-206" data-mp="eoz81oha4htj">
              Session Ready SLP — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-gold-hover" data-id="element-207" data-mp="3i7906al7804x">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-208" data-mp="3n5u0sb4d4ltw">
            <img src={productMockup.src} alt={productMockup.alt} width={1024} height={1024} loading="lazy" className="mx-auto aspect-[4/3] w-full max-w-lg rounded-2xl object-cover" data-id="element-209" data-mp="3rxljy0l6vpa0" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-210" data-mp="2zf7vgrlqtfnl">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-211" data-mp="2mhrt9p627i3n">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-212" data-mp="2mfp7jhbxwb4q">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-213" data-mp="2w7uxklimsiha" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-214" data-mp="23kgx4dfq54sf">
              {/* PENDING (Lucas): confirm the anchor value before launch. */}
              <p className="text-[13px] text-ink-soft" data-id="element-215" data-mp="2dgk8m9wgufs1">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-216" data-mp="3tv3fy7nc5bf2">$90 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-plum" data-id="element-217" data-mp="3owin4taexu0n">
                <span className="mt-2.5 font-display text-3xl" data-id="element-218" data-mp="3oylebgnaxt6y">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-219" data-mp="92geodw4hqu">
                  27
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-220" data-mp="5742li6m4x6j">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-221" data-mp="3rhq255g1m6yx">
                <span className="rounded-full border border-gold bg-gold px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-gold-ink" data-id="element-222" data-mp="j0d5d0022kg3">
                  Save $63
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-223" data-mp="a933mlevri0b">
                  One-time payment
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-224" data-mp="11zhbo107q042">
                  No subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-225" data-mp="3f8blut9lvtys">
                Get instant access — $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-226" data-mp="3aas5nntcl747">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-227" data-mp="3189374th4wih">
                <li className="flex items-center gap-1.5" data-id="element-228" data-mp="1rkk1syyx8c0">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-229" data-mp="3syx2ebbl7rti" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-230" data-mp="3k6lf2ybrskhr">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-231" data-mp="3k63l68ckyid0" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-232" data-mp="fqu26y6qicim">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-233" data-mp="1yfohnpxfb2bz" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-234" data-mp="27i6527ote10k">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}